import { useState } from 'react';
import { Entity, stringifyEntityRef } from '@backstage/catalog-model';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';

export function DeleteCatalogDialog({
  entity,
  onClose,
  onConfirm,
}: {
  entity: Entity;
  onClose: () => void;
  onConfirm: () => void;
}) {
  const catalog = useApi(catalogApiRef);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string>();
  const remove = async () => {
    setBusy(true);
    setError(undefined);
    try {
      const location = await catalog.getLocationByEntity(
        stringifyEntityRef(entity),
      );
      if (location) {
        await catalog.removeLocationById(location.id);
      } else if (entity.metadata.uid) {
        await catalog.removeEntityByUid(entity.metadata.uid);
      } else {
        throw new Error('Catalog entity has no location or UID');
      }
      onConfirm();
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open onClose={busy ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Delete catalog</DialogTitle>
      <DialogContent>
        <Typography>
          Delete {entity.metadata.title || entity.metadata.name} from the
          catalog?
        </Typography>
        <Typography variant="body2">
          The catalog registration and its saved Backstage environment data will
          be removed.
        </Typography>
        <Typography variant="body2">
          The entity may reappear if its catalog registration source still
          exists.
        </Typography>
        {error && (
          <Typography color="error" role="alert">
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>
          Cancel
        </Button>
        <Button onClick={remove} disabled={busy} color="secondary">
          {busy ? 'Deleting...' : 'Delete catalog'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
